import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { TestExecutionDTO, TestExecutionFilterDTO, TestLogDTO, TestLogFilterDTO } from '../../../shared/interfaces';
import { ISnackbarAlert, SnackbarAlert, CardList, TextFieldInput, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter, SelectField } from '../../../shared/components';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { Attribute } from '../../appSphere/attribute/Attribute';
import { TestLogView } from './TestLogView';

interface ITestLogProps {
    data: any;
}

export const TestLog: React.FC<ITestLogProps> = ({ data }) => {

    const [testExecutionList, setTestExecutionList] = useState<TestExecutionDTO[]>([]);
    const [testLogListt, setTestLogList] = useState<TestLogDTO[]>([]);
    const [testLogFilterDTO, setTestLogFilterDTO] = useState<TestLogFilterDTO>();

    const [actionExecuted, setActionExecuted] = useState(false);
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    useEffect(() => {
        setTestLogFilterDTO({
            ...testLogFilterDTO,
            testExecutionId: data.id ?? ''
        });
        handleTestExecutionGetAllAsync();
    }, []);

    useEffect(() => {
        handleTestLogGetAllViewAsync();
    }, [testLogFilterDTO?.testExecutionId]);

    useEffect(() => {
        if (actionExecuted)
            handleTestLogGetAllViewAsync();
    }, [actionExecuted]);

    const handleTestExecutionGetAllAsync = useCallback(async () => {
        const testExecutionFilterDTO: TestExecutionFilterDTO = {
            name: '',
            testComponentId: ''
        };
        GenericService.GetAllAsync1('testingsphere.testexecution', testExecutionFilterDTO, setLoading, setTestExecutionList, showMessage);
    }, []);

    const handleTestLogGetAllViewAsync = useCallback(async () => {
        if (testLogFilterDTO === undefined)
            return;
        GenericService.GetAllViewAsync1('testingsphere.testlog', testLogFilterDTO, setActionExecuted, setLoading, setTestLogList, showMessage);
    }, [testLogFilterDTO]);

    const handleClearFilterClick = () => {
        setTestLogFilterDTO({
            ...testLogFilterDTO,
            name: ''
        } as TestLogFilterDTO);
    };

    function handleSearchClick() {
        handleTestLogGetAllViewAsync();
    }

    const handleViewDetatils = (data: string) => {
        setEditRecord(data);
        setDeleteRecord('');
        setIsOpenMaintenance(true);
    };

    const handleDelete = (data: string) => {
        setDeleteRecord(data);
        setEditRecord('');
        setIsOpenMaintenance(true);
    };

    const toolBarActions: IDialogActions[] = [
        // { id: 'new', text: 'New Feature', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
    ];

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: testLogListt.length },
        { label: 'Name', value: testLogFilterDTO?.name },
        { label: 'TestExecution', value: !data ? testExecutionList.find(x => x.id === testLogFilterDTO?.testExecutionId)?.cycle : undefined },
    ];

    const columns: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 8, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'executionStatus', label: 'Execution Status', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'creationDateTime', label: 'Data de Criação', size: 2, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title='APPLICATION'>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={4}>
                            <TextFieldInput
                                id='name'
                                label='Name'
                                value={testLogFilterDTO?.name}
                                setValue={setTestLogFilterDTO}
                                obj={testLogFilterDTO}
                                placeholder={'Name'}
                                maxLength={200}
                            />
                        </Grid>
                        {!data && (
                            <Grid item xs={12} md={4}>
                                <SelectField
                                    id='testExecutionId'
                                    label='TestExecution'
                                    value={testLogFilterDTO?.testExecutionId}
                                    setValue={setTestLogFilterDTO}
                                    obj={testLogFilterDTO}
                                    valueList={testExecutionList}
                                />
                            </Grid>
                        )}
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                <CardList
                    columns={columns}
                    rows={testLogListt}
                    actions={cardActions}
                    hasChildren={false}
                    setRowExpanded={setExpandedData}
                    cardSize={12}
                    childrenTitle={'ATTTRIBUTE'}
                    childrenComponent={(
                        <Box width={'100%'}>
                            <Attribute data={expadedData} />
                        </Box>
                    )}
                />
                {editRecord && (
                    <TestLogView
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (<Delete
                    entity={'testexecution'}
                    data={deleteRecord}
                    setIsOpenDiaglog={setIsOpenMaintenance}
                    isOpenDialog={isOpenMaintenance}
                    setActionExecuted={setActionExecuted}
                />)}
            </LayoutDashboard>
        </React.Fragment >
    );
};